import { Util } from '@/modules/util'
import type { AffinetyActivityFee } from '@/types/activity'
import { Request } from '@/classes/Request.ts'

export const affinetyActivityFees = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get(
    '/ajax/student/' + studentAccountId + '/affinety_activity_fee'
  )
  const items = Util.Obj.keysToCamel(response.data.items) as AffinetyActivityFee[]

  // Convert date strings to Date objects
  return items.map(item => ({
    ...item,
    date: new Date(item.date)
  }))
}
